import http from '@/api/http'

export default {
  updateActionTime(): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post('/action_update/')
        .then(res => {
          resolve(res.data)
        })
        .catch(reject)
    })
  }
}
